import { render, staticRenderFns } from "./html5Modules.vue?vue&type=template&id=0dbfe21c&"
import script from "./html5Modules.vue?vue&type=script&lang=js&"
export * from "./html5Modules.vue?vue&type=script&lang=js&"
import style0 from "./html5Modules.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports